function comparable(a, b) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}

export function compareIgnoreCase(a, b) {
  return comparable(a.toUpperCase(), b.toUpperCase());
}

export function compare(a, b) {
  return comparable(a, b);
}
